import React from 'react'
import VehicleBasedIntegrations from '../vehicleBasedIntegrations/VehicleBasedIntegrations'
import { useIntegrationDocsURL } from '../../../../../../utils/docs'

const AcPanther: React.FC = () => {
  const integrationDocs = useIntegrationDocsURL()

  return (
    <VehicleBasedIntegrations
      allowAuthentication
      credentialsRequestUrl="/ac-panther/authentication/{companyId}"
      getVehiclesUrl="/ac-panther/vehicles/{companyId}"
      updateVehicleUrl="/ac-panther/vehicles/{companyId}/{id}"
      pageDocsUrl={integrationDocs.external('ac-panther')}
      name="acpanther"
    />
  )
}

export default AcPanther
